jQuery(document).ready(function(){
		jQuery('.login-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		infinite: false,
	});
	jQuery(document).ready(function ($) {

  /* ===============================
     CONFIG
  =============================== */
  const autoplayTime = 5000;
  const circle = document.querySelector('._1H7Vq9_Y circle');
  const radius = 22;
  const circumference = 2 * Math.PI * radius;

  let isPlaying = true;
  let startTime = 0;
  let remainingTime = autoplayTime;
  let paused = false;

  /* ===============================
     CIRCLE FUNCTIONS
  =============================== */
  function resetCircle() {
    circle.style.transition = 'none';
    circle.style.strokeDasharray = circumference;
    circle.style.strokeDashoffset = circumference;
  }

  function animateCircle(duration) {
    resetCircle();
    circle.getBoundingClientRect(); // force reflow
    circle.style.transition = `stroke-dashoffset ${duration}ms linear`;
    circle.style.strokeDashoffset = 0;
    startTime = Date.now();
    remainingTime = duration;
    paused = false;
  }

  function pauseCircle() {
    if (paused) return;

    const elapsed = Date.now() - startTime;
    remainingTime -= elapsed;

    const offset = getComputedStyle(circle).strokeDashoffset;
    circle.style.transition = 'none';
    circle.style.strokeDashoffset = offset;

    paused = true;
  }

  function resumeCircle() {
    if (!paused) return;

    circle.getBoundingClientRect();
    circle.style.transition = `stroke-dashoffset ${remainingTime}ms linear`;
    circle.style.strokeDashoffset = 0;

    startTime = Date.now();
    paused = false;
  }

  /* ===============================
     ICON FUNCTIONS
  =============================== */
  function setPlayIcon() {
    $('#sliderplaybtn').html(`
      <svg class="pause-icon" viewBox="0 0 24 24" width="24" fill="none">
        <path fill="currentColor"
          d="M19.314 11.35L6.367 3.877a.75.75 0 00-1.125.65v14.949a.75.75 0 001.125.649l12.947-7.474a.75.75 0 000-1.3z"/>
      </svg>
    `);
  }

  function setPauseIcon() {
    $('#sliderplaybtn').html(`
      <svg class="play-icon" viewBox="0 0 24 24" width="24" fill="none">
        <path fill="currentColor"
          d="M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z"/>
        <path fill="currentColor"
          d="M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z"/>
      </svg>
    `);
  }

  setPauseIcon();

  /* ===============================
     SLICK INIT
  =============================== */
  const $slider = $('.home-slider');

  $slider
    .on('init', function () {
      animateCircle(autoplayTime);
    })
    .on('beforeChange', function () {
      resetCircle();
    })
    .on('afterChange', function () {

      // 🔥 arrow / swipe / dots → force PLAY
      if (!isPlaying) {
        $slider.slick('slickPlay');
        isPlaying = true;
      }

      animateCircle(autoplayTime);
      setPauseIcon();
    })
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: autoplayTime,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDotsHover: false
    });

  /* ===============================
     PLAY / PAUSE BUTTON
  =============================== */
  $('#sliderplaybtn').on('click', function () {
    if (isPlaying) {
      $slider.slick('slickPause');
      pauseCircle();
      setPlayIcon();
    } else {
      $slider.slick('slickPlay');
      resumeCircle();
      setPauseIcon();
    }
    isPlaying = !isPlaying;
  });

});



	// jQuery('.product-card-slider').slick({
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	infinite: false,
	// 	asNavFor: '.product-nav-slider',
	// });
	// jQuery('.product-nav-slider').slick({
	// 	slidesToShow: 5,
	// 	slidesToScroll: 1,
	// 	swipeToSlide: false,
	// 	asNavFor: '.product-card-slider',
	// 	dots: false,
	// 	arrows: false,
	// 	infinite: false,
	// 	vertical:false,
	// 	focusOnSelect: true,
	// 	responsive: [
			
	// 		{
	// 			breakpoint: 767,
	// 			settings: {
	// 				arrows: true,
	// 				vertical:false,
	// 				dots: false,
	// 				slidesToShow: 4,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
	jQuery('.product-features-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	
	jQuery('.wear-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
 $('.topbar-slider').on('init', function(){
    $(this).css('visibility', 'visible'); 
  }).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    infinite: true
  });
	jQuery('.shopby-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: true,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
	// jQuery('.similar-slider').slick({
	// 	slidesToShow: 4,
	// 	slidesToScroll: 1,
	// 	arrows: true,
	// 	infinite: false,
	// 	responsive: [
	// 		{
	// 			breakpoint: 991,
	// 			settings: {
	// 				slidesToShow: 3,
	// 				slidesToScroll: 1
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 767,
	// 			settings: {
	// 				arrows: false,
	// 				dots: false,
	// 				slidesToShow: 2,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
	jQuery('.combo-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.similar-popup-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
    /*
	jQuery('.curated-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.recently-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
    */
	jQuery('.about-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots:true,
		// infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.women-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
  jQuery('.jdgm-write-rev-link').click(function() {
		jQuery(".review-btn").toggleClass('reviewfull');
    });
	setTimeout(function() {
		jQuery('.category-tab li a, .combo-tab li a').on('click', function(){
			var target = jQuery(this).attr('data-rel');
		 jQuery('.category-tab li a, .combo-tab li a').removeClass('active');
			jQuery(this).addClass('active');
			jQuery("#"+target).fadeIn('slow').siblings(".plp-tab-box, .combo-tab-box").hide();
			jQuery('.product-card-slider, .product-nav-slider, .combo-slider').slick('setPosition');
		});
	}, 1000);
	// $('.size-btn .lotto-btn, .product-dec-bottom-right .lotto-btn').click(function() {
 //        // Toggle the text content
 //        const $textSpan = $(this).find('.size-txt');
 //        const currentText = $textSpan.text();
        
 //        // $textSpan.text(currentText === 'Select size' ? 'Add to Bag' : 'Select size');
        
 //        // Optional: Toggle a class for styling differences
 //        // $(this).toggleClass('added', currentText === 'Select size');
	// 	$(".size-guide").addClass('active');
 //        $(".product-details_add-cart").addClass('active');
 //        $(".product-details_seclect-size").toggleClass('active');
 //    });
	jQuery(document).on('click','.product-col .product-col-top', function(){
		jQuery(this).parent(".product-col").toggleClass('active').siblings().removeClass('active');
	});
		// $(".verify-btn").click(function(){
	// 	$(".complete").addClass('completeshow');
	// 	$(".onboarding-box").addClass('hideonboarding');
	// });
  $(".product-details_add-cart").click(function(){
			$("#addcart-popup").addClass('addcartshow');
		});

  const header = $('.header');
  let lastScroll = 0;

  $(window).scroll(function() {
    const currentScroll = $(this).scrollTop();
    
    if (currentScroll > lastScroll && currentScroll > 50) {
      // Scroll down
      header.addClass('sticky');
      $('main').css('padding-top', header.outerHeight() + 'px');
    } else if (currentScroll + $(window).height() < $(document).height() && currentScroll <= 50) {
      // Near top of page
      header.removeClass('sticky');
      $('main').css('padding-top', '0');
    }
    
    lastScroll = currentScroll;
  });

  // Handle window resize
  $(window).resize(function() {
    if (header.hasClass('sticky')) {
      $('main').css('padding-top', header.outerHeight() + 'px');
    }
  });
  jQuery('.blogs-slider').slick({
			slidesToShow: 2.5,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
    	responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 1.5,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.featured-slider').slick({
			slidesToShow: 3.5,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
    	responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 2.3,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.pdp-features-slider').slick({
		slidesToShow: 3.5,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
    	responsive: [
			{
				breakpoint: 1199,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 2.5,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 1.5,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.wear-sec-slider').slick({
		slidesToShow: 3.1,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
    	responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 1.5,
					slidesToScroll: 1
				}
			}
		]
	});
	// jQuery('.featured-product-slider').slick({
	// 	slidesToShow: 3.5,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	infinite: false,
    // 	responsive: [
	// 		{
	// 			breakpoint: 767,
	// 			settings: {
	// 				arrows: false,
	// 				dots: false,
	// 				infinite: false,
	// 				slidesToShow: 2.3,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
	jQuery(document).ready(function ($) {

  $('.featured-product-slider').slick({
    slidesToShow: 3.5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,

    responsive: [
      {
        breakpoint: 768,
        settings: "unslick" // 👈 mobile pe slider hata dega
      }
    ]
  });

});
	$(".featurd-tab li").click(function () {
      let index = $(this).index();
      $(".featurd-tab li").removeClass("active");
      $(this).addClass("active");
      $(".featurd-product-tab").hide();
      $(".featurd-product-tab").eq(index).fadeIn();
	  jQuery('.featured-product-slider').slick('setPosition');
    });
	$(".size-left-top li").click(function () {
    let index = $(this).index();

    // Tab active
    $(".size-left-top li").removeClass("active");
    $(this).addClass("active");

    // Tab switch
    $(".size-guide-tab").hide();
    $(".size-guide-tab").eq(index).fadeIn();

    // Add class to .size-guide-sec based on clicked tab
    let selectedClass = $(this).data("tab"); // sizein or sizecm
    $(".size-guide-sec")
        .removeClass("sizein sizecm")   // remove old classes
        .addClass(selectedClass);       // add new class
});
	jQuery('.shop-collection-slider').slick({
		slidesToShow: 3.5,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
    	responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 2.3,
					slidesToScroll: 1
				}
			}
		]
	});
	// jQuery('.shop-the-main').slick({
	// 	slidesToShow: 3,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	infinite: false,
    // 	responsive: [
	// 		{
	// 			breakpoint: 767,
	// 			settings: {
	// 				arrows: false,
	// 				dots: false,
	// 				infinite: false,
	// 				slidesToShow: 2,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
	$(document).on("click", ".lotto-plp-atc-btn-desktop", function (e) {
    e.stopPropagation();

    let card = $(this).closest(".product-card");
    let dropdown = card.find(".wishlist_dropdown");

    // Close all other dropdowns
    // $(".wishlist_dropdown").not(dropdown).slideUp(200);
    $(".product-card").not(card).removeClass("active");
    $(".lotto-plp-atc-btn-desktop").not(this).removeClass("active");

    // Toggle this one
    // dropdown.slideToggle(200);
    card.toggleClass("active");
    $(this).toggleClass("active");
});

// Close dropdown when clicking outside
$(document).on("click", function () {
    // $(".wishlist_dropdown").slideUp(200);
    $(".product-card").removeClass("active");
    $(".lotto-plp-atc-btn-desktop").removeClass("active");
});
  
	if(window.matchMedia("(min-width: 768px)").matches){
		jQuery('.trends-slider').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			arrows: true,
			infinite: false,
		});
	}
  
	if(window.matchMedia("(max-width: 991px)").matches){
		$(".menu-icon").click(function(){
			$(".nav").addClass('navshow');
		});
		
		$(".nav-close").click(function(){
			$(".nav").removeClass('navshow');
			$(".nav-item, .menu-col").removeClass('active');
		});
		$('.nav').on('click', '.first-step, .second-step', function(e) {
			e.preventDefault();
			const $target = $(this).closest('.nav-item, .menu-col');
			$target.toggleClass('active').siblings().removeClass('active');
			
			// Close child menus when parent closes
			if (!$target.hasClass('active')) {
				$target.find('.active').removeClass('active');
			}
		});

		jQuery('.first-step-back, .second-step-back').click(function() {
			jQuery(this).closest(".nav-item, .menu-col").removeClass('active');
		});
	}

	if(window.matchMedia("(max-width: 767px)").matches){
      
  //       jQuery('.mobile-facets').on('click', function(){
		//  jQuery('.mobile-facets__disclosure').removeClass('menu-opening');
		// });
		jQuery('.product-details-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			infinite: false,
			asNavFor: '.product-item-slider',
		});
		jQuery('.product-item-slider').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			swipeToSlide: false,
			asNavFor: '.product-details-slider',
			dots: false,
			arrows: false,
			infinite: false,
			vertical:false,
			focusOnSelect: true,
		});
		jQuery('.cloud-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
		});
		jQuery(document).on('click','.seo-accordion .lottoxxsheading', function(){
			jQuery(this).parent(".seo-accordion").toggleClass('active').siblings().removeClass('active');
		});
		jQuery('.footer-mid .footer-col .lottoxxsheading').click( function(){
			jQuery(this).parent(".footer-col").toggleClass('active').siblings().removeClass('active');
		});
	}
});
document.addEventListener('DOMContentLoaded', function() {
	// Step elements
	const stepOne = document.querySelector('.login-stepone');
	const stepTwo = document.querySelector('.login-steptwo');
	const stepThree = document.querySelector('.login-stepthree');
	const completeProfile = document.querySelector('.complete');
	const onboarding = document.querySelector('.onboarding-box');
	
	// Buttons
	const loginTwoBtn = document.querySelector('.login-twobtn');
	const loginThreeBtn = document.querySelector('.login-threebtn');
	const editBtn = document.querySelector('.edit-btn');
	const verifyBtn = document.querySelector('.verify-btn');
  
	// Step 1  Step 2
	// if(loginTwoBtn) {
	//   loginTwoBtn.addEventListener('click', (e) => {
	// 	e.preventDefault();
	// 	stepOne.classList.add('d-none');
	// 	stepTwo.classList.add('show-steptwo');
	//   });
	// }
  
	// Step 2 → Step 3
	// if(loginThreeBtn) {
	//   loginThreeBtn.addEventListener('click', (e) => {
	// 	e.preventDefault();
	// 	stepTwo.classList.remove('show-steptwo');
	// 	stepThree.classList.add('show-stepthree');
	//   });
	// }
  
	// Step 3 → Step 2 (Edit button)
	// if(editBtn) {
	//   editBtn.addEventListener('click', (e) => {
	// 	e.preventDefault();
	// 	stepThree.classList.remove('show-stepthree');
	// 	stepTwo.classList.add('show-steptwo');
	//   });
	// }
	// if(verifyBtn) {
	// 	verifyBtn.addEventListener('click', (e) => {
	// 	  e.preventDefault();
	// 	  onboarding.classList.add('hideonboarding');
	// 	  completeProfile.classList.add('completeshow');
	// 	});
	//   }

	const faqItems = document.querySelectorAll('.footer-faq-item');
	if (faqItems.length > 0) {
		faqItems[0].classList.add('active');
	}
	const faqTops = document.querySelectorAll('.footer-faq-question');
	faqTops.forEach(top => {
		top.addEventListener('click', function () {
			const faqItem = this.closest('.footer-faq-item');
			const isActive = faqItem.classList.contains('active');
			faqItems.forEach(item => {
				item.classList.remove('active');
			});
			if (!isActive) {
				faqItem.classList.add('active');
			}
		});
	});
  });

// ###############################################################################################

	jQuery('.faq-col .faq-top').click( function(){
		jQuery(this).parent(".faq-col").toggleClass('active').siblings().removeClass('active');
	});
$(document).ready(function() {
  const slider = $('.trends-slider, .blogs-slider');
  const track = $('.scrollbar-track');
  const handle = $('.scrollbar-handle');
  let isDragging = false;
  let startX;
  let startLeft;

  function getTranslateX(element) {
    const transform = element.css('transform');
    if (!transform || transform === 'none') return 0;
    const matrix = transform.match(/^matrix\((.+)\)$/);
    if (matrix) {
      const values = matrix[1].split(', ');
      return parseFloat(values[4]);
    }
    const translate = transform.match(/translateX\((.+?)px\)/);
    return translate ? parseFloat(translate[1]) : 0;
  }

  function updateScrollbar() {
      const slick = slider.slick('getSlick');
    try{
      const slideCount = slick.slideCount;
      const slidesToShow = slick.options.slidesToShow || 1;
      const trackWidth = track.outerWidth();
      const handleWidth = (slidesToShow / slideCount) * trackWidth;
      
      handle.css('width', handleWidth);
      
      const currentSlide = slick.currentSlide;
      const maxScroll = trackWidth - handleWidth;
      const position = maxScroll > 0 ? (currentSlide / (slideCount - slidesToShow)) * maxScroll : 0;
      handle.css('transform', `translateX(${position}px)`);
      
    }catch(err){
      console.log(err)
    }
  }

  slider.on('init afterChange', updateScrollbar);

  handle.on('mousedown', function(e) {
    isDragging = true;
    startX = e.clientX;
    startLeft = getTranslateX(handle);
    handle.addClass('no-transition');
    e.preventDefault();
  });

  $(document).on('mousemove', function(e) {
    if (!isDragging) return;
    const deltaX = e.clientX - startX;
    let newLeft = startLeft + deltaX;
    const trackWidth = track.outerWidth();
    const handleWidth = handle.outerWidth();
    const maxScroll = trackWidth - handleWidth;
    
    newLeft = Math.max(0, Math.min(newLeft, maxScroll));
    handle.css('transform', `translateX(${newLeft}px)`);

    if (maxScroll > 0) {
      const slick = slider.slick('getSlick');
      const slideCount = slick.slideCount;
      const slidesToShow = slick.options.slidesToShow || 1;
      const slideIndex = Math.round((newLeft / maxScroll) * (slideCount - slidesToShow));
      slider.slick('slickGoTo', slideIndex);
    }
  });

  $(document).on('mouseup', function() {
    isDragging = false;
    handle.removeClass('no-transition');
  });

  $(window).on('resize', updateScrollbar);

  // Initialize Slick slider
  // slider.slick({
  //   arrows: false,
  //   dots: false,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   infinite: false,
  //   speed: 300
  // });
});



document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.size-head-tag');
 
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
 
      // Remove active class from all
      tabs.forEach(t => t.classList.remove('active'));
 
      // Add active class to clicked
      this.classList.add('active');
 
      // Get target section selector
      const targetSelector = this.getAttribute('data-target');
      const target = document.querySelector(targetSelector);
 
      if (target) {
        // Smooth scroll inside popup
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });
});
